import React from 'react';

const LoadingSpinner = ({ size = 'medium', color = '#2563eb', text = 'Loading...' }) => {
  const sizeMap = {
    small: { width: 16, height: 16, borderWidth: 2 },
    medium: { width: 24, height: 24, borderWidth: 3 },
    large: { width: 32, height: 32, borderWidth: 4 }
  };

  const { width, height, borderWidth } = sizeMap[size];

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      gap: 8
    }}>
      <div
        style={{
          width: width,
          height: height,
          border: `${borderWidth}px solid #e5e7eb`,
          borderTop: `${borderWidth}px solid ${color}`,
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      />
      {text && (
        <div style={{ 
          color: '#64748b', 
          fontSize: size === 'small' ? '0.875rem' : '1rem',
          fontWeight: 500
        }}>
          {text}
        </div>
      )}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner; 